import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter, withComponentInputBinding, RouteReuseStrategy } from '@angular/router';
import { provideIonicAngular, IonicRouteStrategy } from '@ionic/angular/standalone';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideServiceWorker } from '@angular/service-worker';
import { routes } from './app.routes';
import {
  apiClientProvider,
  tokenStoreProvider,
} from './core/http/api-client.provider';
import { pushPortProviders } from './core/push/push.providers';
import { environment } from '../environments/environment';

// Phase 8 HARD-03: dropped the classic `IonicModule.forRoot()` import that lived
// alongside `provideIonicAngular()`. `provideIonicAngular` is the standalone
// equivalent and already configures the same `mode: 'md'`. The legacy
// `IonicModule` (from '@ionic/angular') was a duplicate registration AND
// dragged the classic NgModule bundle into the eager chunk. Removing it is
// strictly safe per Ionic 7.5+ standalone-app guidance.
export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({ mode: 'md' }),
    provideRouter(routes, withComponentInputBinding()),
    // Async-loaded: the ~53 KB @angular/animations browser renderer is moved
    // out of the eager bundle and loaded on first animation request (Ionic
    // page transitions trigger this on the first navigation). Saves bundle
    // initial weight; the cold-start UX delta is negligible since Ionic's
    // own page-transition machinery doesn't fire until after first nav.
    provideAnimationsAsync(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    apiClientProvider,
    tokenStoreProvider,
    ...pushPortProviders,
  ],
};
